import { render } from "./ThematicAxesAccordion.vue?vue&type=template&id=28a35590&scoped=true"
import script from "./ThematicAxesAccordion.vue?vue&type=script&lang=js"
export * from "./ThematicAxesAccordion.vue?vue&type=script&lang=js"

import "./ThematicAxesAccordion.vue?vue&type=style&index=0&id=28a35590&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-28a35590"]])

export default __exports__